import { IconTypeEnum } from "@components/common/icon";

export enum CircleIconColorEnum {
  Green = "Green",
  Red = "Red"
}

export type CircleIconProps = {
  type: IconTypeEnum;
  color: CircleIconColorEnum;
}
